"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("baseui/modal/styled-components");

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _CloseIcon = _interopRequireDefault(require("./CloseIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Same as baseui Close, except uses a custom close icon. */
const Close = props => {
  const {
    closeType = 'large',
    ...buiCloseProps
  } = props;
  const [css, theme] = (0, _theme.useStyletron)();
  const backgroundColor = closeType === 'large' ? theme.colors.white : 'transparent';
  const margin = closeType === 'large' ? '1.5rem' : '0rem';
  const width = closeType === 'large' ? '1.125rem' : '0.75rem';
  return /*#__PURE__*/_react.default.createElement(_styledComponents.Close, _extends({}, buiCloseProps, {
    $style: {
      position: 'absolute',
      top: 0,
      right: 0,
      height: '2.5rem',
      width: '2.5rem',
      borderTopLeftRadius: '50%',
      borderTopRightRadius: '50%',
      borderBottomLeftRadius: '50%',
      borderBottomRightRadius: '50%',
      marginTop: margin,
      marginRight: margin,
      marginBottom: margin,
      marginLeft: margin,
      background: backgroundColor,
      transition: 'none',
      ':focus': {
        border: 'none',
        filter: 'contrast(2)'
      },
      ':hover': {
        opacity: 0.75
      }
    },
    "data-testid": "modal-close-button"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: css({
      width: width,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    })
  }, /*#__PURE__*/_react.default.createElement(_CloseIcon.default, null)));
};

var _default = Close;
exports.default = _default;